import { createI18n } from 'vue-i18n'
import axios from 'axios'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../constants'
import dayjs from 'dayjs'
import locales from '../locales'

const i18n = createI18n({
  legacy: false
})

export function setLocale(lang) {
  if (!SUPPORTED_LOCALES.includes(lang)) {
    return
  }
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  dayjs.locale(lang)

  Object.keys(locales).forEach(locale => {
    i18n.global.setLocaleMessage(locale, locales[locale])
  })
  i18n.global.locale.value = lang
}

setLocale(DEFAULT_LOCALE)

export default i18n
